<template>
  <div>
    <!-- 位置名称 动态 -->
    <bread-crumb></bread-crumb>
    <div class="pgcQaDetail-info">
      <div class="base-title">{{ curQa?.manufacturer }} {{ curQa?.genericName || curQa?.skuName  }} {{ curQa?.specification }}的提问</div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2}"
        placeholder="请输入内容"
        v-model="curQuestionAndAnswers.question">
      </el-input>
      <div class="base-title">{{ curQa?.manufacturer }} {{ curQa?.genericName || curQa?.skuName  }} {{ curQa?.specification }}的回答</div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2}"
        placeholder="请输入内容"
        v-model="curQuestionAndAnswers.answer">
      </el-input>
      <div class="pgcQaDetail-info-btn">
        <el-button type="primary" @click="updateQa">修改问答</el-button>
      </div>
    </div>
    <!-- <el-form ref="pgc-search-form" :model="form" label-width="100px" class="pgcQa-search">
      <el-form-item label="提问审核结果">
        <el-select v-model="form.questionStatus" placeholder="请选择">
          <el-option
            key="99"
            label="请选择"
            value=""
          ></el-option>
          <el-option
            key="1"
            label="待提交"
            value="1"
          ></el-option>
          <el-option
            key="2"
            label="提交失败"
            value="2"
          ></el-option>
          <el-option
            key="3"
            label="待审核"
            value="3"
          ></el-option>
          <el-option
            key="4"
            label="审核通过"
            value="4"
          ></el-option>
          <el-option
            key="5"
            label="审核删除"
            value="5"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回答审核结果">
        <el-select v-model="form.answerStatus" placeholder="请选择">
          <el-option
            key="99"
            label="请选择"
            value=""
          ></el-option>
          <el-option
            key="1"
            label="待提交"
            value="1"
          ></el-option>
          <el-option
            key="2"
            label="提交失败"
            value="2"
          ></el-option>
          <el-option
            key="3"
            label="待审核"
            value="3"
          ></el-option>
          <el-option
            key="4"
            label="审核通过"
            value="4"
          ></el-option>
          <el-option
            key="5"
            label="审核删除"
            value="5"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="SKU">
        <el-input style="width: 300px" v-model="form.skuId" placeholder="请输入药品SKU进行检索"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="onSumit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="pgcQa-iebtns">
      <el-button size="small" type="primary" @click="deleteQas">批量删除</el-button>
    </div> -->
    <!-- <div class="pgcQa--tabel">
      <div class="base-table">
        <div class="base-table-table">
          <el-table :data="pgcQaList" :border="true" @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="100">
            </el-table-column>
            <el-table-column
              prop="skuId"
              label="SKU"
              width="200">
            </el-table-column>
            <el-table-column
              prop="genericName"
              label="商品名称"
            >
            </el-table-column>
            <el-table-column
              prop="manufacturer"
              label="生产厂家"
              >
            </el-table-column>
            <el-table-column
              prop="specification"
              label="药品规格"
            >
            </el-table-column>
            <el-table-column
              label="提问审核结果"
            >
              <template slot-scope="scope">
                <span>{{ statusArr[scope.row.questionStatus] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="questionRejectReason"
              label="审核未通过原因"
            >
            </el-table-column>
            <el-table-column
              label="回答审核结果"
            >
              <template slot-scope="scope">
                <span>{{ statusArr[scope.row.answerStatus] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="answerRejectReason"
              label="回答审核未通过原因"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div> -->
    <!-- <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    /> -->
  </div>
</template>

<script>
import breadCrumb from "@/components/wiki/breadCrumb";
import pagination from "@/components/wiki/pagination";

import { pgcSelectQuestionSkuList, pgcUpdateQuestionAndAnswer, pgcBatchdel } from "@/api/man";

export default {
  name: "diseaseList",
  data() {
    return {
      type:new URLSearchParams(window.location.search).get('type'),
      form: {
        skuId: '',
        questionStatus: '',
        answerStatus: ''
      },
      // 列表数据
      pgcQaList:[],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      statusArr: ['','待提交','提交失败','待审核','审核通过','审核删除'],
      // 当前选中的问答
      selectEdQas: [],
      curQuestionAndAnswers: {},
      curQa: {}
    }
  },
  components: {
    breadCrumb,
    pagination
  },
  created() {
    const drugQuestionAndAnswers = localStorage.getItem('drugQuestionAndAnswers');
    const qalist = localStorage.getItem('pgcQaList');
    if (drugQuestionAndAnswers) {
      const dqas = JSON.parse(drugQuestionAndAnswers);
      const curquestionId = this.$route.query.questionId;
      this.curQuestionAndAnswers = dqas.find((dqa) => dqa.questionId == curquestionId);
      console.log("🚀 ~ file: editQas.vue:120 ~ created ~ this.curQuestionAndAnswers:", this.curQuestionAndAnswers)
    }
    if(qalist) {
      const qalistArr = JSON.parse(qalist);
      const curDurgId = this.$route.query.drugId
      this.curQa = qalistArr.find((qa) => (qa.drugId == curDurgId) || (qa.skuId == curDurgId))
    }
    this.getQuestionSkuList();
  },
  methods: {
    // 获取数据
    getQuestionSkuList(val) {
      if (val) {
        this.paginationDataProduct.currentPage = val;
      }
      console.log("=====????/")
      pgcSelectQuestionSkuList({
        pgcDrugId: this.curQa?.pgcDrugId,
        drugId: this.curQa?.drugId,
        questionId: this.curQuestionAndAnswers.questionId,
        pageSize: this.paginationDataProduct.pageSize,
        pageNum: this.paginationDataProduct.currentPage,
        ...this.form
      }).then(res => {
        console.log("🚀 ~ file: editQas.vue:208 ~ getQuestionSkuList ~ res:", res)
        this.pgcQaList = res.list;
        // 本地存储，用于详情页展示和查询
        localStorage.setItem('pgcQaList',JSON.stringify(res.list));
        this.paginationDataProduct.total = res.total;
        this.paginationDataProduct.currentPage = res.pageNum;
        this.paginationDataProduct.pageSize = res.pageSize;
      })
    },
    // 搜索
    onSumit() {
      console.log('form', this.form)
      this.paginationDataProduct.currentPage = 1;
      this.getQuestionSkuList();
    },
    // 重置
    reset(){
      this.form = {
        skuId: '',
        questionStatus: '',
        answerStatus: ''
      }
      this.paginationDataProduct.currentPage = 1;
    },
    // 切换页码
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      console.log('paginationChangeProduct', this.paginationDataProduct)
      this.getQuestionSkuList()
    },
    // 修改问答
    updateQa(){
      pgcUpdateQuestionAndAnswer({
        pgcDrugId: this.curQa?.pgcDrugId,
        drugId: this.curQa?.drugId,
        questionId: this.curQuestionAndAnswers.questionId,
        answerId: this.curQuestionAndAnswers.answerId,
        question: this.curQuestionAndAnswers.question,
        answer: this.curQuestionAndAnswers.answer,
        type: this.type
      }).then(res=>{
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      }).catch(e=>{
        console.log('e', e);
      })
    },
    // 批量删除
    deleteQas(){
      if (this.selectEdQas.length > 0 ) {
        let strs = '';
        this.selectEdQas.forEach((it) => {
          strs += `,${it.questionId}`
        })
        strs = strs.slice(1);
        console.log("🚀 ~ file: pgcQaDetail.vue:212 ~ doDelete ~ strs:", strs, this.selectEdQas)
        pgcBatchdel({
          questionAuditInfos: this.selectEdQas
        }).then(res => {
          console.log("🚀 ~ file: pgcQaDetail.vue:216 ~ doDelete ~ res:", res)
          this.$message('删除成功');
          this.getDrugQuestionAndAnswers()
        })
      }
    },
    // 多选改变时
    handleSelectionChange(val) {
      console.log("🚀 ~ file: pgcQaDetail.vue:154 ~ handleSelectionChange ~ val:", val)
      this.selectEdQas = val;
    },
  }
};
</script>

<style lang="scss" scoped>
.pgcQaDetail-info{
  padding: 20px 0px 20px 33px;
  background: #fff;
  margin-bottom: 10px;
  font-size: 14px;
  color: rgb(81, 101, 121);
  .base-title{
    margin: 10px 0;
  }
  .pgcQaDetail-info-btn{
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.pgcQa-search{
  display: flex;
  padding: 20px 0px 20px 33px ;
  margin-bottom: 10px;
  align-items: center;
  background: #fff;
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
